import {FileInfoView} from '@modifi/onboarding-api-clients'
import createCachedSelector from 're-reselect'
import {INPUT_FIELD_DOCUMENT_TYPE_MAP} from '@modifi/plugin-onboarding'
import {selectDocuments} from './collection'

export const selectDocumentsByInputFieldName = createCachedSelector(
  selectDocuments,
  (state: Record<string, any>, inputFieldName: string) => {
    if (typeof INPUT_FIELD_DOCUMENT_TYPE_MAP[inputFieldName] !== 'undefined') {
      return INPUT_FIELD_DOCUMENT_TYPE_MAP[inputFieldName]
    }
    return null
  },
  (companyDocuments, documentTypeFilter) => {
    if (!documentTypeFilter) {
      return [] as FileInfoView[]
    }
    return companyDocuments.filter(d => d.documentType === documentTypeFilter)
  }
)((state, inputFieldName) => inputFieldName)
